import PaginatedTable from "../../components/PaginatedTable/PaginatedTable";
import { TPaginationProps, TTableProps } from "../../types/types";

type Props<T> = {
    tableProps: TTableProps<T>;
    pagination: TPaginationProps<T>;
    onSearch: (term: string) => void;
    renderChild?: () => JSX.Element;
};

export default function InspectionPaginatedTable<T>({ tableProps, pagination, onSearch, renderChild }: Props<T>) {
    return (
        <PaginatedTable
            withSearch
            noMargin
            tableProps={tableProps}
            pagination={pagination}
            handleSearch={onSearch}
            renderChild={renderChild}
        />
    );
}
